class Customer.UserProfileAttributeView extends Backbone.View
  className: 'user-profile-attribute custom-attribute'
  error: JST['backbone/templates/customer/custom_attributes/error']

  initialize: ({attribute}) ->
    @model = attribute
    @$el.toggleClass('required', @model.isRequired())

  render: ->
    @$el.html(@template(model: @model))
    @

  initialValues: ->
    _.map(@model.get('value'), (val) -> val['value']) || []

  afterRender: ->

  markAsError: ->
    @$el.addClass('error')

  cleanErrors: ->
    @$el.removeClass('error')

  _errorTemplate: (error) =>
    @error({error})
